<template>
  <div>
    <header-slot>
      <template v-slot:content-right>
        <div class="h-100">
          <b-button
            v-b-tooltip.hover.left="$t('Create new travel')"
            variant="outline-primary btn-icon"
            @click="$refs.routerViewTab.createTravel()"
          >
            {{ $t("Create travel") }}
          </b-button>
        </div>
      </template>
    </header-slot>

    <b-nav card-header pills class="m-0">
      <b-nav-item
        v-for="(item, index) in tabs"
        :key="index"
        :to="{ name: item.name }"
        exact
        exact-active-class="active"
        :link-classes="['px-3', bgTabsNavs]"
        >{{ $t(item.title) }}
      </b-nav-item>
    </b-nav>

    <b-card
      no-body
      class="border-top-primary border-3 border-table-radius px-0"
    >
      <router-view ref="routerViewTab" :key="routeName" />
    </b-card>
  </div>
</template>

<script>
export default {
  name: "TravelOrders",
  components: {},
  directives: {},
  data() {
    return {};
  },
  created() {},
  computed: {
    tabs() {
      return this.$route.matched[1].meta.tabs;
    },
    routeName() {
      return this.$route.name;
    },
  },
  methods: {},
};
</script>

<style>
</style>